import { render } from "./ViewEtudiantPage.vue?vue&type=template&id=614cd235&ts=true"
import script from "./ViewEtudiantPage.vue?vue&type=script&lang=ts"
export * from "./ViewEtudiantPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__